/* import __COLOCATED_TEMPLATE__ from './jp-smirf-enrollment-success.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();